const REACT_APP_SSTAPI = process.env.REACT_APP_SSTAPI
const API_URL = process.env.REACT_APP_SSTAPI+'/api/v1'

export { REACT_APP_SSTAPI, API_URL }